<template>
    <div class="interface-help">
        <h2>Текстовый редактор</h2>
        <p>
            Данный интерфейс, имитирует работу с текстовым редактором.
        </p>
        <p>
            Инструменты форматирования текста, представлены только визуально. Доступен только ввод текста. Для этого предусмотрено поле слева.<br>
            <img class="interface-help__image interface-help__image--1" src="/images/help/editor-textarea.jpg" alt="">
        </p>
        <p>
            Общий вид текстового редактора<br>
            <img class="interface-help__image" src="/images/help/editor.jpg" alt="">
        </p>
    </div>
</template>
<script>
    export default {}
</script>
<style lang="stylus" scoped>
    .interface-help {
        p {
            max-width 80%
        }

        &__image {
            max-width 60%
            border 1px solid rgba(0, 0, 0, .4)

            &--1 {
                max-width 40%
            }
        }
    }
</style>